<template>
  <div class="mt-8 text-center">
    <h1 class="errorPageTitle mb-0">404</h1>
    <p class="errorPageSubTitle">Not Found</p>
    <p>
      ページが存在しません。ページが削除された、もしくは移動された可能性があります。
    </p>
    <a :href="mediaRootPath()">
      <v-btn class="mt-8 errorPageButton" outlined> トップページへ </v-btn>
    </a>
  </div>
</template>

<script>
import urlUtils from '@/mixins/url_utils'

export default {
  name: 'NotFound',
  mixins: [urlUtils]
}
</script>

<style scoped>
.errorPageTitle {
  font-size: 5rem;
  font-weight: 600;
  letter-spacing: 5px;
}
.errorPageSubTitle {
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 2px;
  line-height: 2;
}
.errorPageButton {
  width: 200px;
  height: 50px !important;
}
</style>
